import { useRequest } from '@10000/react'
import { createHash } from '@10000/react/src/deviceHash'
import { Body, Box, Button, H3 } from '../../widgets'
import { useShell } from '../../layout'
import { assetUrl } from '../../../utilities.js'
import './Splash.scss'

export const Splash = ({ active, name, avatar }) => {
  const request = useRequest('squiz')

  useShell({ active, mode: 'navigate' })
  const join = async () => request('participantJoined', { name, avatar, hash: await createHash() })

  return (
    <Box
      className="squiz-splash"
      fullWidth
      fullHeight
      background={`var(--black-fade), var(--red)`}
    >
      <Box className="desktop-only" fullWidth background={`url(${assetUrl('eyes.png')}) 0 100px / cover`}/>

      <Box fullWidth justifyContent="center">
        <Box column maxWidth={400} gap={32} p={32} className="content">
          <H3>Before we start</H3>
          <Body align="center">
            <Body alt bold italic>Shivoo</Body> is designed for group analysis and actionable insights.
            You&apos;re about to experience the <Body alt bold italic>free solo version</Body> with limited features.
          </Body>
          <Button fullWidth onClick={join}>
            Got it
          </Button>
        </Box>
      </Box>
    </Box>
  )
}